<div>
  <ng-container *ngComponentOutlet="component; injector: myInjector"></ng-container>
</div>
